import React from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { FormikInputField } from '../../../../../components/v3/InputField/FormikInput';
import styles from './increaseLimitModal.module.css';
import { useTealium} from '../../../../../tealium/useTealium';
import { useLocation } from 'react-router-dom';
import {
  Footer
} from '../../../../../components';

export const FieldTypes = {
  INPUT: 'input',
  CURRENCYINPUT: 'currency_amount_input'
};

export const LimitIncreaseForm = ({
  fields,
  title,
  subtitle,
  isMobile,
  values,
  FormField,
  errors,
  backClick,
  nextClick,
  touched,
  requireFooter = true,
  isNextAllowed = true
}) => {

  const { setFieldValue } = useFormikContext();
  const { track, events } = useTealium();
  const location = useLocation();

  const getErrorClassName = (hasError, fieldType = '') => {
    if (hasError) {
      return styles.errorContainer;
    } else if (fieldType !== 'paired') {
      return styles.fieldContainer;
    } else {
      return '';
    }
  };

  const renderInput = (field, fieldClassName) => {
    return (
      <div className={styles.btmMargin}>
        <div style={FormField}>
          {field.label && (
            <div className={styles.fieldLabel}>
              {field.label}
            </div>
          )}

          <Field component={FormikInputField} {...field.props} className={fieldClassName} disabled={field.props.disabled ? true : false} />

        </div>
      </div>
    );
  };

  const renderCurrencyAmountInput = (field, fieldClassName) => {
    const hasError = Object.keys(touched).includes(field?.props?.name) && errors[field?.props?.name];

    return (
      <div className={!hasError ? styles.btmMargin : styles.errorBtmMargin}>
        <div style={FormField}>
          {field.label && (
            <div className={styles.fieldLabel}>
              {field.label}
            </div>
          )}
          <div className={styles.loanInputContainer} >

            {values[field?.props?.name] ?
              <span className={styles.currency} >R{' '}</span>
              :
              <span className={styles.errorCurrency} />
            }
            <div className={styles.inputFieldContainer}>
              <Field component={FormikInputField}
                value={(values[field?.props?.name] ?? '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                onChange={(e) => {
                  const raw = e.target.value.replace(/\D/g, '');
                  track(events.limitIncrease.fieldInteraction(location.pathname, field?.props?.name, raw, 'limit increase'));
                  setFieldValue(field?.props?.name, raw);
                }}
                {...field.props} className={fieldClassName} disabled={field.props.disabled ? true : false} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const rightCallback = () => {
    return Object.values(errors)?.length ? null : nextClick;
  };

  const renderField = (field, fieldType) => {

    const hasError = Object.keys(touched).includes(field?.props?.name) && errors[field?.props?.name];
    const fieldClassName = getErrorClassName(hasError, fieldType);

    switch (field?.type) {
      case FieldTypes.INPUT:
        return renderInput(field, fieldClassName);

      case FieldTypes.CURRENCYINPUT:
        return renderCurrencyAmountInput(field, fieldClassName, hasError);

      default:
        return null;
    }
  };

  const renderFormFields = () => {
    return fields?.map((field, index) => {
      return <React.Fragment key={index}>{renderField(field)}</React.Fragment>;
    });
  };

  return (
    <div className={styles.container}>
      <div className={isMobile ? styles.mobileTitleContainer : styles.titleContainer}>
        <div className={isMobile ? styles.mobileTitleHeading : styles.titleHeading}>
          {title}
        </div>
        {subtitle && (
          <div className={styles.titleSubHeading}>
            {subtitle}
          </div>
        )}
      </div>
      <div className={styles.formWrapper}>
        {renderFormFields()}
      </div>
      {requireFooter && (
        <Footer
          leftTitle={'Cancel'}
          rightTitle={'Confirm'}
          leftCallback={backClick}
          rightCallback={rightCallback()}
          shouldShowSubmit
          isNextAllowed={isNextAllowed}
        />
      )}
    </div>
  );
};

LimitIncreaseForm.propTypes = {
  fields: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  isMobile: PropTypes.bool,
  values: PropTypes.object,
  FormField: PropTypes.object,
  errors: PropTypes.object,
  backClick: PropTypes.func,
  nextClick: PropTypes.func,
  touched: PropTypes.object,
  requireFooter: PropTypes.bool,
  isNextAllowed: PropTypes.bool
};
